import { Component, Prop, Vue } from 'vue-property-decorator';
import { authMethodIsWeak } from '@/helpers/Authentication';
import { authenticationMethod } from '@/helpers/Environment';
import { openMembershipModal } from '@/modals/membershipModal';
import { logout } from '@/state/Authentication';
import store from '@/store/store';
@Component({ name: 'MembersMenu' })
export default class default_1 extends Vue {
    @Prop({ required: true })
    user;
    t;
    get showAccountLinks() {
        if (authenticationMethod == null)
            return false;
        else {
            const cart = store.getters['Cart/cart'];
            // Disable login for injected carts; direct checkout payment links, cart hand-off and payment for edited orders.
            if (!cart)
                return true;
            else
                return cart.ownedByPublicIdentity;
        }
    }
    openMembershipModal() {
        this.close();
        openMembershipModal();
    }
    async logOut() {
        return logout(this.$router, '/');
    }
    close() {
        const el = this.$refs.memberMenu;
        el.removeAttribute('open');
    }
    get showMySection() {
        return !authMethodIsWeak;
    }
}
